import api from "../../core/api"
import { logout } from "../../core/utils"

const Types = {
    FECTH: "contrato/FECTH",
    BUSCA: "contrato/BUSCA",
    DETALHE: "contrato/DETALHE",
    LOADING: "contrato/LOADING"
}

const INITIAL_STATE = {
    data: [],
    total: 0,
    loading: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Types.FECTH: {
            return { ...state, data: action.payload, total: action.payload.length }
        }
        case Types.LOADING: {
            return { ...state, loading: action.payload }
        }
        default:
            return state
    }
}

export const Creators = {
    fetch: () => dispatch => {
        api.get("/contratos")
            .then(response => {
                dispatch({
                    type: Types.FECTH,
                    payload: response.data.contratos
                })
            })
            .catch(err => logout())
    },
    detail: id => dispatch => {
        dispatch({
            type: Types.LOADING,
            payload: true
        })
        api.get("/contratos/" + id)
            .then(response => {
                dispatch({
                    type: Types.FECTH,
                    payload: response.data.contrato
                })
                dispatch({
                    type: Types.LOADING,
                    payload: false
                })
            })
            .catch(err => logout())
    }
}
